import React from 'react'
import { makeStyles } from '@material-ui/core'
import { ProColleaguesTableRow, Table, TablePagination } from 'components'
import { useDispatch, useSelector } from 'react-redux'
import { colors } from 'constants/index'
import { setConnectionFilter, getColleagueConnections, setTableConfiguration } from 'store/actions/connections'

const useStyles = makeStyles({
  connectionsTable: {
    marginTop: 20,
  },
  tableHeaderCell: {
    borderBottom: `2px solid ${colors.BASIC.COLOR[10]}`,
  },
})

const columns = [
  {
    value: 'full_name',
    label: 'Colleague name',
    sortable: true,
  },
  {
    value: 'contacts',
    label: 'Contacts',
    sortable: false,
  },
  {
    value: 'address',
    label: 'Address',
    sortable: false,
  },
  {
    value: 'buttons',
    label: '',
    sortable: false,
  },
]

const ProColleaguesTable = ({ colleagues, count, profileIsApproved }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const sorting = useSelector(state => state.connections.sort)
  const { limit, tablePage } = useSelector(state => state.connections.tableConfiguration)

  const onSort = (name, isAcs) => {
    // Sorting can be implemented later if needed
    dispatch(
      setTableConfiguration({
        tablePage: 0,
        offset: 0,
      })
    )
    dispatch(getColleagueConnections())
  }

  const onRowsPerPageChange = value => {
    dispatch(
      setTableConfiguration({
        tablePage: 0,
        offset: 0,
        limit: value,
      })
    )
    dispatch(getColleagueConnections())
  }

  const onPageChange = value => {
    dispatch(
      setTableConfiguration({
        tablePage: value,
        offset: value * limit,
      })
    )
    dispatch(getColleagueConnections())
  }

  return (
    <Table
      tableColumns={columns}
      className={classes.connectionsTable}
      tableHeaderCellClass={{ root: classes.tableHeaderCell }}
      tableData={colleagues}
      sorting={sorting}
      onSort={onSort}
      tableDataRowRenderer={(columns, data) => (
        <ProColleaguesTableRow columns={columns} data={data} profileIsApproved={profileIsApproved} />
      )}
      footer={
        <TablePagination
          colSpan={columns.length}
          page={tablePage}
          count={count}
          rowsPerPage={limit}
          rowsPerPageOptions={[10, 20, 50]}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={onPageChange}
        />
      }
      activeRows
    />
  )
}

export default ProColleaguesTable
